import MainModel from "../../../components/Models/main-model";
import {
    Box,
    Flex,
    FormLabel,
    Heading,
    Stack,
    Textarea,
    Button,
    VStack,
    HStack,
    Text,
} from "@chakra-ui/react";
import { useSelector, useDispatch } from "react-redux";
import { closeRefuseHomeworkModel } from "../../../modules/admin-modules/models/Actions";
import { useState, useEffect } from "react";
import { getAllHomeworksRequest } from "../../../modules/admin-modules/homework/Actions";
import { deleteStuentHomeworkRequest } from "../../../modules/admin-modules/reports/Actions";
import { getAssistantsRequest } from "../../../modules/admin-modules/teachersAssistant/Actions";
import Select from "react-select";
const HomeworkRefuseComment = ({ data, homeworkId }) => {
    const baseUrl = "https://asquera.com/asquera";

    const openHomeworkComment = useSelector((state) => state.model.isOpen32);
    const [comment, setComment] = useState("");
    const dispatch = useDispatch();
    const assistants = useSelector((state) => state.teacherassistants.assistants);
    const [assistant, setAssistant] = useState("");
    const [assistantComment, setAssistantComment] = useState("");
    const assistantsOptions = assistants?.data?.map((data) => {
        return { value: data.id, label: data.name, sign: data.school };
    });
    const colourStyles = {
        control: (styles) => ({
            ...styles,
            width: "100%",
            background: "#f5f5f5",
            color: "#690000",
            borderRadius: "16px",
        }),
        option: (styles) => ({ ...styles, color: "#690000" }),
    };
    useEffect(() => {
        dispatch(getAssistantsRequest());
    }, []);
    const header = (
        <Box>
            <Heading textAlign="center" color="main_1" fontSize="24px"></Heading>
        </Box>
    );
    const handelAddComment = async () => {
        await dispatch(deleteStuentHomeworkRequest({
            evaluation: comment,
            student_id: data?.student?.id,
            homework_id: data?.homework?.id,
            assistant_id: assistant,
            assistant_comment: assistantComment,
        }));
        dispatch(closeRefuseHomeworkModel());
    };
    const closeFunc = () => {
        dispatch(closeRefuseHomeworkModel());
    };

    const setEvalation = (evalation) => () => {
        setComment(evalation);
        // set the text area value to the evalation
        document.getElementById("homework").value = evalation;
    };
    return (
        <MainModel
            isLoading={false}
            header={header}
            closeFunc={closeFunc}
            openVar={openHomeworkComment}
            buttonTitle={"حفظ التغيرات"}
            buttonFunc={handelAddComment}
        >
            <VStack dir="rtl">
                <HStack w="100%">
                    <FormLabel> الطالب : {data?.student?.name} </FormLabel>
                    <FormLabel> الواجب : {data?.homework?.name} </FormLabel>
                    <Button
                        as="a"
                        href={`https://docs.google.com/gview?url=${baseUrl}${data?.file}`}
                        target="_blank"
                    >
                        الحل
                    </Button>
                </HStack>

                <HStack w="100%">
                    <Button onClick={setEvalation("تم رفض واجبك بسبب نقص الخطوات، يرجى إكمال الخطوات ورفع الواجب مرة أخرى")}>
                        الخطوات ناقصة
                    </Button>
                    <Button onClick={setEvalation("تم رفض واجبك بسبب وجود العديد من الأسئلة الخاطئة، يرجى مراجعة الواجب باستخدام فيديو الحل ورفعه مرة أخرى")}>
                        الحل غير صحيح
                    </Button>
                    <Button onClick={setEvalation("تم رفض واجبك بسبب نقص بعض الأسئلة، يرجى إكمال الواجب ورفعه مرة أخرى")}>
                        الحل غير مكتمل
                    </Button>
                    <Button onClick={setEvalation("تم رفض واجبك لأنك قمت برفع ملف واجب غير صحيح، يرجى رفع ملف الواجب الصحيح")}>
                        الملف الخاطئ
                    </Button>
               
                </HStack>
                <Box w="100%">
                    <FormLabel> الملاحظات : </FormLabel>
                    <Textarea
                        bg="#f5f5f5"
                        placeholder="اكتب الملاحظات"
                        onChange={(e) => setComment(e.target.value)}
                        name="homework"
                        id="homework"
                    ></Textarea>
                </Box>

                <Box w="100%">
                    <FormLabel> اختر المساعد : </FormLabel>
                    <Select
                        styles={colourStyles}
                        options={assistantsOptions}
                        onChange={(e) => {
                            setAssistant(e.value);
                            document.getElementById("homework").value += "\n\n" + e.sign;
                            setComment(document.getElementById("homework").value);
                        }}
                        placeholder="اختر المساعد"
                    />
                </Box>

                <Box w="100%">
                    <FormLabel> ملاحظات المساعد : </FormLabel>
                    <Textarea
                        id="assistantComment"
                        bg="#f5f5f5"
                        placeholder="اكتب الملاحظات"
                        onChange={(e) => setAssistantComment(e.target.value)}
                        name="homework"
                    ></Textarea>
                </Box>

                {data?.last_homework != null && (
                    <Box w="100%" p={3} bg="#f5f5f5" borderRadius="16px">
                        <FormLabel> الواجب السابق : </FormLabel>
                        {typeof data.last_homework === "string" ? (
                            <Text whiteSpace="pre-wrap">{data.last_homework}</Text>
                        ) : (
                            <VStack align="stretch" spacing={2}>
                                {data.last_homework.homework?.name && (
                                    <Text>الاسم: {data.last_homework.homework.name}</Text>
                                )}
                                {data.last_homework.created_at && (
                                    <Text>
                                        التاريخ:{" "}
                                        {new Date(data.last_homework.created_at).toLocaleString(
                                            "en-GB",
                                            {
                                                day: "2-digit",
                                                month: "2-digit",
                                                year: "numeric",
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                hour12: false,
                                            }
                                        ).replace(",", "")}
                                    </Text>
                                )}
                                {data.last_homework.evaluation && (
                                    <Box>
                                        <FormLabel> التصحيح السابق : </FormLabel>
                                        <Text whiteSpace="pre-wrap">
                                            {data.last_homework.evaluation}
                                        </Text>
                                    </Box>
                                )}
                                {data.last_homework.assistant_comment && (
                                    <Box>
                                        <FormLabel> ملاحظات المساعد السابقة : </FormLabel>
                                        <Text whiteSpace="pre-wrap">
                                            {data.last_homework.assistant_comment}
                                        </Text>
                                    </Box>
                                )}
                                {data.last_homework.file && (
                                    <Button
                                        as="a"
                                        href={`https://docs.google.com/gview?url=${baseUrl}${data.last_homework.file}`}
                                        target="_blank"
                                        alignSelf="flex-start"
                                    >
                                        الحل السابق
                                    </Button>
                                )}
                            </VStack>
                        )}
                    </Box>
                )}
            </VStack>
        </MainModel>
    );
};

export default HomeworkRefuseComment;
